import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../../styles/notfound.module.css';

export default function NotFound() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h1 className={styles.code}>404</h1>
        <p className={styles.message}>Page not found</p>
        <p className={styles.info}>We couldn't find the page you're looking for.</p>

        <div className={styles.suggest}>Here are some helpful links:</div>
        <div className={styles.suggestions}>
          <Link to="/blogs" className={styles.slink}>News</Link>
          <Link to="/calender" className={styles.slink}>Calendar</Link>
        </div>

        <div className={styles.actions}>
          <Link to="/" className={styles.button}>Go home</Link>
        </div>
      </div>
    </div>
  );
}
